// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";

const form: TvmFormDefinition = {
	"flags": {
		"demersal": {
			"expression": "trawlSystem==1",
			"defValue": true
		}
	},
	"hints": {
		"htmlDef": "<div style=\"font-family: Helvetica; font-size: 22px;\">     <p>{{form_flotation_hints_p1}}</p>     {{form_flotation_hints_img_1}}     {{form_flotation_hints_img_2}}     {{form_flotation_hints_img_3}} </div>",
		"title": "Flotación y Lastre"
	},
	"fields": {
		"trawlSystem": {
			"inputType": "select",
			"type": "SELECT",
			"index": 1,
			"label": "$form_flotation_fishing_system",
			"selectOptions": [
				{
					"key": 1,
					"label": "$form_flotation_fishing_system_demersal"
				},
				{
					"key": 0,
					"label": "$form_flotation_fishing_system_crustacean"
				}
			],
			"value": "0",
			"name": "trawlSystem"
		},
		"upperHeadrope": {
			"name": "upperHeadrope",
			"value": "0",
			"index": 0,
			"label": "$form_flotation_headrope_length",
			"type": "INPUT",
			"inputType": "number"
		}
	},
	"formula": {
		"maxBallastDemersal": "(upperHeadrope * 12) * 1.1",
		"maxFlotationDemersal": "upperHeadrope * 12",
		"minBallastDemersal": "(upperHeadrope * 4.8) * 1.1",
		"minFlotationCrustacean": "upperHeadrope * 1.8",
		"minBallastCrustacean": "(upperHeadrope * 1.8) * 1.1",
		"maxBallastCrustacean": "(upperHeadrope * 2.2) * 1.1",
		"minFlotationDemersal": "upperHeadrope * 4.8",
		"maxFlotationCrustacean": "upperHeadrope * 2.2"
	}
};

export const flotation = form;
